import { featuredNews } from "@/mocks/homeNews";
import { MetaRow, SectionHead, Tag } from "./bits";

export default function FeaturedSection() {
  return (
    <section id="dujia" className="bg-background-100/70 border-y border-background-200">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-14">
        <SectionHead
          eyebrow="独家首发"
          title="每日黑料独家大曝光"
          desc="每一条都为您精选：冠以「独家 / 曝光 / 内幕」的封面故事，是今天最值得你停下来看的一屏。"
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 md:gap-5">
          {featuredNews.map((s, i) => (
            <article key={s.id} className="group relative overflow-hidden rounded-lg cursor-pointer bg-background-50">
              <div className="relative aspect-[4/5] w-full overflow-hidden">
                <img
                  src={s.image}
                  alt={s.title}
                  title={`${s.title} | 每日黑料独家曝光`}
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
                <div className="absolute top-3 left-3 flex items-center gap-2">
                  <Tag label={s.tag} tone={s.tagTone || "secondary"} />
                </div>
                <div className="absolute inset-x-0 bottom-0 p-4">
                  <span className="mb-2 inline-flex items-center gap-1 text-[11px] font-semibold text-accent-300">
                    封面故事 · {String(i + 1).padStart(2, "0")}
                  </span>
                  <h3 className="font-heading text-[15px] font-bold text-white leading-snug line-clamp-3">
                    {s.title}
                  </h3>
                </div>
              </div>
              <div className="border-t border-background-200 bg-background-50 px-4 py-3">
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">{s.summary}</p>
                <div className="mt-2.5">
                  <MetaRow time={s.time} reads={s.reads} />
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}